<template>
  <FadeTransition>
    <div
      v-if="showBar"
      :key="`route-loading-${route.path}-${loadingRequestId}`"
      class="route-loading-bar"
      :class="{ 'route-loading-bar-complete': isComplete }"
      :style="{ width: isComplete ? '100%' : undefined }"/>
  </FadeTransition>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouteLoadingStore } from '@shared/stores/routeLoading.js'
import { useRoute } from 'vue-router'
import FadeTransition from '@shared/components/ADORN/transitions/FadeTransition.vue'

const { isRouteLoading, loadingRequestId } = storeToRefs(useRouteLoadingStore())
const route = useRoute()

const showBar = ref(false)
const isComplete = ref(false)

watch(isRouteLoading, (loading) => {
  if (loading) {
    showBar.value = true
    isComplete.value = false
  } else if (showBar.value) {
    isComplete.value = true
    nextTick(() => {
      setTimeout(() => {
        showBar.value = false
        isComplete.value = false
      }, 300)
    })
  }
}, { immediate: true })
</script>

<style lang="scss">
.route-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 2px;
  background: $orchid;
  z-index: 9999999999;
  box-shadow: 0 0 4px rgba($orchid, 0.5);
  width: 0%;
  animation: route-loading-progress 1.5s ease-out;
}

@keyframes route-loading-progress {
  0% {
    width: 0%;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 70%;
  }
}

.route-loading-bar-complete {
  width: 100% !important;
  animation: none;
  transition: width 0.2s ease-out;
}
</style>
